<template>
  <div class="hero is-custom">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-one-third is-4 has-text-centered-touch">
            <h1 class="title is-4 has-text-black">¿Te interesa estar al tanto de todas las actividades abiertas relacionadas a la incubadora de proyectos de Ciudades Comunes?</h1>
            <h1 class="title is-3 larger animated pulse slower infinite"><a class="has-text-white" href="https://docs.google.com/forms/d/e/1FAIpQLSe18mgHqJPUof9o4U2z2MOuAaakrmKd7ddhe1-h575etxlyAQ/viewform" target="_blank"><u>suscribite</u></a></h1>
          </div>
          <div class="column is-offset-1 has-text-centered-touch">
            <!-- <h1 class="title is-2 larger is-hidden-touch"><a class="has-text-white" href="https://docs.google.com/forms/d/e/1FAIpQLSe18mgHqJPUof9o4U2z2MOuAaakrmKd7ddhe1-h575etxlyAQ/viewform" target="_blank"><u>inscribite</u></a></h1> -->
            <h1 class="title is-2 larger has-text-black">Síguenos</h1>
            <div class="content is-large">
              <p><a href="https://twitter.com/ciudadescomunes" class="has-text-black"><i class="fab fa-twitter"></i> @ciudadescomunes</a></p>
              <p><a href="https://facebook.com/ciudadescomunes" class="has-text-black"><i class="fab fa-facebook"></i> @ciudadescomunes</a></p>
              <p><a href="https://instagram.com/ciudades.comunes" class="has-text-black"><i class="fab fa-instagram"></i> @ciudades.comunes</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.is-custom{
  background-color: #f2652b
}
.larger{
  font-size: 3.5rem;
}
.more-larger{
  font-size: 5rem;
}
</style>